import { render, staticRenderFns } from "./BrowserControls.vue?vue&type=template&id=189d0905&"
import script from "./BrowserControls.vue?vue&type=script&lang=ts&"
export * from "./BrowserControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports